///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="processEditor-module.ts"/>

module ProcessEditor {

    /**
     * Helper to only append the transform to the existing ones
     * so the default behavior is retained.
     * From https://docs.angularjs.org/api/ng/service/$http
     */
    export function appendTransform(defaults, transform) {
        // We can't guarantee that the default transformation is an array
        defaults = angular.isArray(defaults) ? defaults : [defaults];
        // Append the new transformation to the defaults
        return defaults.concat(transform);
    }

    export class EnvironmentVariablesService {
        static $inject = ["$http", "$q", "environmentVariableDataResourceUrl"];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService, private environmentVariableDataResourceUrl: string) {
        }

        public getEnvironmentVariables(): ng.IHttpPromise<string[]> {
            return this.$http({
                url: this.environmentVariableDataResourceUrl,
                method: "GET",
                transformResponse: appendTransform(this.$http.defaults.transformResponse, (response: Frends.IJsonResponse) => {
                    if (response.success) {
                        return <string[]>angular.fromJson(response.data);
                    }
                })
            });
        }
    }

    app.service("EnvironmentVariablesService", EnvironmentVariablesService);
}